// extracted by mini-css-extract-plugin
export default {"div":"DadosUsuario_div__7yleD","img":"DadosUsuario_img__a+b6x"};